/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */
import { theme } from "@nordcloud/gnui";

export function displayToolColor(type: string) {
  switch (type) {
    case "INTERNAL":
      return theme.colors.actions[4];
    case "EXTERNAL":
      return theme.colors.actions[3];
    case "DEPRECATED":
      return theme.colors.actions[1];
    default:
      return "-";
  }
}
